import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import {
  BasicDetail,
  Currency,
  RegistrationIds,
} from "../../../../assets/interface/primeSharkWebsite_interface";
import { useTranslation } from "react-i18next";
import { Label } from "../../../Common/Label/Label";
import "react-intl-tel-input/dist/main.css";
import HelperService from "../../../../Services/HelperService";
import WebService from "../../../../Services/WebService";
import { toast } from "react-toastify";
import CompoLoader from "../../../ComponentLoader/CompoLoader";
import CommonScrollbar from "../../../Common/ScrollBar/CommonScrollbar";
import { ACCOUNT_TYPE_API } from "../../../../assets/constants/constants";
import dropdownApiCall, {
  getProfileJourneyInfo,
  isMobileNumberValid,
} from "../../../../Services/CommonFunction";
import PhoneInput1 from "../../../PhoneInput/PhoneInput1";
import { Link, useLocation } from "react-router-dom";
import Select from "react-dropdown-select";
import RequiredLabel from "../../../Common/RequiredLabel/RequiredLabel";
import CurrencySelect from "../../../Common/CurrencyDropDown/CurrencyDropdwon";
import { useDispatch, useSelector } from "react-redux";
import { storePrefferedCurrency } from "../../../../config/action";
import { MdVerifiedUser } from "react-icons/md";
import PasswordInput, { validatePassword } from "../../../Common/PasswordInput";
import { isWarning } from "../../Helper";
import VerifyMobileOTP from "../../../Profile/VerifyMobile";
import VerifyEmailOTP from "../../../Profile/VerifyEmailOTP";
import ChangeEmailModal from "../../../Profile/ChangeEmail";
import ChangeMobileNumberModal from "../../../Profile/ChangeMobileNumber";


interface PropsData {
  handleNext: any;
  impIds: RegistrationIds;
  from?: string;
  fields_to_improve?: any;
  emailVerified?: boolean;
  editMode?: "BASIC" | "BUSINESS_DESC";
}
const BasicDetails = ({
  handleNext,
  impIds,
  from,
  fields_to_improve,
  emailVerified,
  editMode = "BASIC",
}: PropsData) => {
  let account_type = impIds?.account_type ?? "";
  const [emailVerifiedAt, setEmailVerifiedAt] = useState(false);
  const [mobileVerifiedAt, setMobileVerifiedat] = useState(false);
  let dispatch = useDispatch();
  const { t } = useTranslation();
  const [errorFlag, setErrorFlag] = useState(false);
  const [loader, setLoader] = useState(false);
  const [phoneKey, setPhoneKey] = useState(1);
  const [showOTPVerify, setShowOTPVerify] = useState(false);
  const [dial_code, setdial_Code] = useState("");
  const [mobile_number, setMoible_number] = useState("");
  const [country_code, setCountryCode] = useState("");
  const selectedCurrency: Currency = useSelector(
    (state: any) => state?.items?.storedPrefferedCurrency,
  );
  const [showChangeMobileModal, setShowChangeMobileModal] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [email, setEmail] = useState("");
  const [showEmailOTPVerify, setShowEmailOTPVerify] = useState(false);
  const [basicDetails, setBasicDetails] = useState<BasicDetail>({
    first_name: "",
    last_name: "",
    email: "",
    company_name: "",
    dial_code: "",
    country_code: "",
    mobile_number: "",
    password: "",
    login_type: impIds?.login_type?.toLocaleUpperCase() ?? "",
    account_type: impIds?.account_type?.toLocaleUpperCase() ?? "",
    brief_about_business: "",
    vision_mission: "",
    business_entity_type: "",
    business_entity_type_other: "",
    preferred_currency: selectedCurrency ? selectedCurrency?.code : "",
    login_field: "NONE",
    social_id: "",
    mode: from === "FROM_PROFILE_ANALYSIS" ? "FROM_PROFILE_ANALYSIS" : null,
  });
  const [business_entity_typeList, setbusiness_entity_typeList] = useState<
    any[]
  >([]);
  const [apiCallTriggered, setAPICallTriggered] = useState(false);
  const stored_password = sessionStorage.getItem("temp_password");
  let locationVar = useLocation();
  const socialData = locationVar?.state?.social_data;
  const [skipButtonClicked, setSkipButtonClicked] = useState(false);
  useEffect(() => {
    if (socialData) {
      setBasicDetails((prev: BasicDetail) => ({
        ...prev,
        // split name if needed
        first_name: socialData?.name?.split(" ")[0] || "",
        last_name: socialData?.name?.split(" ").slice(1).join(" ") || "",

        email: socialData?.email || "",

        // optional (if you store provider info)
        login_field: socialData?.provider,
        social_id: socialData?.provider_id,
      }));

      // setEmailVerifiedAt(true);
    }
  }, [socialData]);

  useEffect(() => {
    if (emailVerified) {
      setEmailVerifiedAt(true);

      setBasicDetails((prev: any) => ({
        ...prev,
        email_verified_at: new Date().toISOString(),
      }));
    }
  }, [emailVerified]);
  useEffect(() => {
    dropdownApiCall(account_type?.toLocaleLowerCase(), "business_entity_type")
      .then((data: any) => {
        let formatData = data.map((item: any) => ({
          label: item.title,
          value: item.title,
        }));
        setbusiness_entity_typeList(formatData);
      })
      .catch(() => { })
      .finally(() => { });
    const targetUuid = impIds?.uuid || localStorage.getItem("x-info-id") || localStorage.getItem("user_uuid");
    if (targetUuid) {
      getBasicDetails(targetUuid);
    }
  }, [impIds?.uuid]);
  let location = useLocation();
  let status = location?.state?.disable;

  const getBasicDetails = (customUuid?: string) => {
    const targetUuid =
      customUuid ||
      impIds?.uuid ||
      localStorage.getItem("x-info-id") ||
      localStorage.getItem("user_uuid");
    if (!targetUuid) return;

    setLoader(true);
    return WebService.getAPI({
      action: `get-detail/${targetUuid}`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          let info = res?.info;
          let companyInfo = res?.info?.companies;
          let businessInfo = res?.info?.business_info;
          setBasicDetails((prevBasicDetails: BasicDetail) => ({
            ...prevBasicDetails,
            first_name: info?.first_name ?? prevBasicDetails.first_name,
            last_name: info?.last_name ?? prevBasicDetails.last_name,
            company_name:
              companyInfo?.company_name ||
              info?.company_name ||
              businessInfo?.company_name ||
              prevBasicDetails.company_name ||
              "",
            mobile_number: info?.mobile_number ?? prevBasicDetails.mobile_number,
            dial_code: info?.dial_code ?? prevBasicDetails.dial_code,
            country_code: info?.country_code ?? prevBasicDetails.country_code,
            email: info?.email ?? prevBasicDetails.email,
            brief_about_business:
              businessInfo?.entrepreneur_business_details?.brief_about_business ??
              prevBasicDetails.brief_about_business,
            preferred_currency:
              info?.preferred_currency ?? prevBasicDetails.preferred_currency,
            vision_mission:
              businessInfo?.entrepreneur_business_details?.vision_mission ??
              prevBasicDetails.vision_mission,
            business_entity_type:
              businessInfo?.entrepreneur_business_details?.business_entity_type ??
              prevBasicDetails.business_entity_type,
            business_entity_type_other:
              businessInfo?.entrepreneur_business_details
                ?.business_entity_type_other ??
              prevBasicDetails.business_entity_type_other,
            mobile_verified_at: info?.mobile_verified_at ?? prevBasicDetails.mobile_verified_at,
            password:
              from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && impIds?.business_uuid
                ? stored_password || ""
                : "",
          }));
          if (info?.currency) {
            dispatch(storePrefferedCurrency(info?.currency));
          }

          setEmailVerifiedAt(
            res?.info?.email_verified_at != null ? true : false,
          );
          setMobileVerifiedat(
            res?.info?.mobile_verified_at !== null ? true : false,
          );
          setPhoneKey((prev) => prev + 1);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === "brief_about_business" || name === "vision_mission") {
      if (value?.length > 700) return;
    }
    setBasicDetails((prevBasicDetails: BasicDetail) => ({
      ...prevBasicDetails,
      [name]: value,
    }));
  };
  const handleSaveBasicDetails = (flag: boolean) => {
    if (editMode === "BUSINESS_DESC") {
      setErrorFlag(false);
      handleUpdateBasicDetailsApiCall(flag);
      return;
    }

    if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
      // In review/modal edit mode, validate core fields without blocking on read-only/unpopulated fields
      if (!basicDetails?.first_name || !basicDetails?.email) {
        setErrorFlag(true);
        return;
      }
      if (!HelperService.isValidEmail(basicDetails.email)) {
        setErrorFlag(true);
        return;
      }
      if (
        basicDetails?.business_entity_type === "Other" &&
        !basicDetails?.business_entity_type_other
      ) {
        setErrorFlag(true);
        return;
      }
      setErrorFlag(false);
    } else {
      if (
        HelperService?.checkFormEmptyFields(basicDetails, [
          "login_type",
          "account_type",
          "business_entity_type_other",
          "password",
          "mobile_number",
          "dial_code",
          "country_code",
          "preferred_currency",
          "social_id",
          "mobile_verified_at",
          "mode",
          "business_entity_type",
          "vision_mission",
          "brief_about_business",
          "last_name",
          "login_field",
        ])
      ) {
        setErrorFlag(true);
        return;
      } else if (
        basicDetails?.business_entity_type === "Other" &&
        !basicDetails?.business_entity_type_other
      ) {
        setErrorFlag(true);
        return;
      } else if (
        !basicDetails?.password || !validatePassword(basicDetails?.password)
      ) {
        setErrorFlag(true);
        return;
      } else if (!HelperService.isValidEmail(basicDetails.email)) {
        setErrorFlag(true);
        return;
      } else {
        setErrorFlag(false);
      }
    }

    const businessUuid = impIds?.business_uuid || localStorage.getItem("business_uuid");
    if (businessUuid) {
      handleUpdateBasicDetailsApiCall(flag);
    } else {
      handleSaveBasicDetailsApiCall(flag);
    }
  };
  const { FCMDeviceToken } = useSelector((state: any) => state.items);
  const handleSaveBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = {
      ...basicDetails,
      mobile_number: basicDetails?.mobile_number
        ? HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        )
        : null,
      device_token: FCMDeviceToken,
    };

    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");
    setAPICallTriggered(true);

    let apiAccountType = "investment";
    const lowerType = (account_type || impIds?.account_type || "").toLowerCase();
    if (lowerType.includes("grow")) {
      apiAccountType = "want-to-grow";
    } else if (lowerType.includes("sell")) {
      apiAccountType = "want-to-sell";
    } else {
      apiAccountType = "investment";
    }

    return WebService.postAPI({
      action: `basic-detail/${apiAccountType}`,
      body: updatedata,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          WebService.removeLoader("save_basic_details");
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number ?? null,
            basicDetails?.dial_code ?? null,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
        setAPICallTriggered(false);
      });
  };
  const handleUpdateBasicDetailsApiCall = (flag: boolean) => {
    let updatedata = {
      ...basicDetails,
      mobile_number: basicDetails?.mobile_number
        ? HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        )
        : null,
    };
    if (flag) WebService.addLoader("skip_basic_details");
    else WebService.addLoader("save_basic_details");

    let apiAccountType = "investment";
    const lowerType = (account_type || impIds?.account_type || "").toLowerCase();
    if (lowerType.includes("grow")) {
      apiAccountType = "want-to-grow";
    } else if (lowerType.includes("sell")) {
      apiAccountType = "want-to-sell";
    } else {
      apiAccountType = "investment";
    }

    const userUuid = impIds?.uuid || localStorage.getItem("x-info-id") || localStorage.getItem("user_uuid") || "";
    const businessUuid = impIds?.business_uuid || localStorage.getItem("business_uuid") || "";

    return WebService.putAPI({
      action: `basic-detail/${apiAccountType}/${userUuid}/${businessUuid}`,
      body: updatedata,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status) {
          if (
            // !res?.mobile_verification_required &&
            !res?.email_verification_required
          )
            toast.success(res.message);
          if (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") {
            getProfileJourneyInfo(
              apiAccountType,
              businessUuid,
              dispatch,
            );
          }
          handleNext(
            res,
            basicDetails?.email,
            basicDetails?.mobile_number,
            basicDetails?.dial_code,
            // res?.mobile_verification_required,
            res?.email_verification_required,
            basicDetails?.country_code,
          );
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        if (flag) WebService.removeLoader("skip_basic_details");
        else WebService.removeLoader("save_basic_details");
      });
  };

  const handlePhoneChange = (value: any, countryData: any) => {
    setBasicDetails((prevBasicDetails: BasicDetail) => ({
      ...prevBasicDetails,
      dial_code: countryData?.dialCode,
      mobile_number: value,
      country_code: countryData?.iso2,
    }));
  };
  const handleArrayValueChange = (value: any[], key: string) => {
    setBasicDetails((prevDetails: BasicDetail) => ({
      ...prevDetails,
      [key]: Array.isArray(prevDetails[key as keyof BasicDetail])
        ? value.map((item) => ({ title: item?.value }))
        : value[0]?.value,
    }));
  };
  const handleSendOTP = () => {
    WebService.addLoader("verify-otp");
    const isProfileMode = from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS";
    const apiCall = isProfileMode ? WebService.postAPI : WebService.beforeLoginPostAPI;
    const action = isProfileMode ? "verify-mobile/send-otp" : "otp/resend";

    return apiCall({
      action: action,
      body: {
        login_field: "MOBILE_NUMBER",
        mobile_number: HelperService.removeDialCode(
          basicDetails?.mobile_number,
          basicDetails?.dial_code,
        ),
        email: basicDetails?.email,
        dial_code: basicDetails?.dial_code,
        country_code: basicDetails?.country_code,
      },
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          toast.success(res.message);
          setMoible_number(basicDetails?.mobile_number || "");
          setdial_Code(basicDetails?.dial_code || "");
          setCountryCode(basicDetails?.country_code || "");
          setShowOTPVerify(true);
        } else {
          toast.error(res.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
      })
      .finally(() => {
        WebService.removeLoader("verify-otp");
      });
  };
  return (
    <>
      <div className="login-form w-100 px-0 position-relative">
        {loader ? <CompoLoader /> : null}
        {editMode !== "BUSINESS_DESC" && (
          <>
            <div className="custom-title my-auto font-bold mb-2">
              {t("entrepenure_investment_basic_details.heading")}
            </div>
            <p className="font-14 mb-1">
              {t("entrepenure_investment_basic_details.description")}
            </p>
          </>
        )}
        <CommonScrollbar height={editMode === "BUSINESS_DESC" ? "auto" : "65vh"}>
          <div className="p-2 me-2">
            {editMode !== "BUSINESS_DESC" ? (
              <>
                <div className="mb-2 d-flex gap-2">
                  <div className="w-50">
                    <RequiredLabel isRequired={true}>
                      {t("entrepenure_investment_basic_details.first_name_label")}
                    </RequiredLabel>
                    <Form.Control
                      className={
                        (!basicDetails?.first_name && skipButtonClicked) ||
                          isWarning(fields_to_improve, "first_name")
                          ? "warning-field "
                          : ""
                      }
                      type="text"
                      placeholder={t(
                        "entrepenure_investment_basic_details.first_name_placeholder",
                      )}
                      name="first_name"
                      disabled={
                        from === "REVIEW" ||
                        from === "FROM_PROFILE_ANALYSIS" ||
                        status
                      }
                      value={basicDetails?.first_name}
                      onChange={handleChange}
                    />
                    {!skipButtonClicked && errorFlag && !basicDetails?.first_name && (
                      <Label
                        title={t(
                          "entrepenure_investment_basic_details.error_first_name",
                        )}
                        modeError={true}
                      />
                    )}
                  </div>
                  <div className="w-50">
                    <RequiredLabel isRequired={true}>
                      {t("entrepenure_investment_basic_details.last_name_label")}
                    </RequiredLabel>
                    <Form.Control
                      type="text"
                      className={
                        (!basicDetails?.last_name && skipButtonClicked) ||
                          isWarning(fields_to_improve, "last_name")
                          ? "warning-field "
                          : ""
                      }
                      placeholder={t(
                        "entrepenure_investment_basic_details.last_name_placeholder",
                      )}
                      name="last_name"
                      disabled={
                        from === "REVIEW" ||
                        from === "FROM_PROFILE_ANALYSIS" ||
                        status
                      }
                      value={basicDetails?.last_name}
                      onChange={handleChange}
                    />
                    {!skipButtonClicked && errorFlag && !basicDetails?.last_name && (
                      <Label
                        title={t(
                          "entrepenure_investment_basic_details.error_last_name",
                        )}
                        modeError={true}
                      />
                    )}
                  </div>
                </div>

                <div className="d-flex gap-1">
                  <div className="mb-2 w-50">
                    <RequiredLabel isRequired={true}>
                      {t("entrepenure_investment_basic_details.company_name_label")}
                    </RequiredLabel>
                    <Form.Control
                      className={
                        (!basicDetails?.company_name && skipButtonClicked) ||
                          isWarning(fields_to_improve, "company_name")
                          ? "warning-field"
                          : ""
                      }
                      type="text"
                      placeholder={t(
                        "entrepenure_investment_basic_details.company_name_placeholder",
                      )}
                      name="company_name"
                      value={basicDetails?.company_name}
                      onChange={handleChange}
                    />
                    {!skipButtonClicked &&
                      errorFlag &&
                      !basicDetails?.company_name && (
                        <Label
                          title={t(
                            "entrepenure_investment_basic_details.error_company_name",
                          )}
                          modeError={true}
                        />
                      )}
                  </div>
                  <div className="w-50">
                    <RequiredLabel isRequired={true}>
                      {t(
                        "entrepenure_investment_basic_details.preferred_currency_label",
                      )}
                    </RequiredLabel>
                    <CurrencySelect
                      isDisabled={from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"}
                      className={
                        (!basicDetails?.preferred_currency && skipButtonClicked) ||
                          isWarning(fields_to_improve, "preferred_currency")
                          ? "warning-field"
                          : ""
                      }
                      onChange={(value: any) => {
                        console.log("Selected currency", value);
                        if (value?.value) {
                          setBasicDetails((prev: BasicDetail) => ({
                            ...prev,
                            preferred_currency: value?.value,
                          }));
                        }
                      }}
                    />
                    {!skipButtonClicked &&
                      errorFlag &&
                      !basicDetails?.preferred_currency && (
                        <Label
                          title={t(
                            "entrepenure_investment_basic_details.error_currency",
                          )}
                          modeError={true}
                        />
                      )}
                  </div>
                </div>

                <div className="mb-2">
                  <RequiredLabel isRequired={false}>
                    {t("entrepenure_investment_basic_details.business_entity_label")}
                  </RequiredLabel>
                  <Select
                    className={
                      isWarning(fields_to_improve, "business_entity_type")
                        ? "warning-field"
                        : ""
                    }
                    dropdownHeight="200px"
                    options={
                      business_entity_typeList?.length > 0
                        ? business_entity_typeList
                        : []
                    }
                    onChange={(values: any) => {
                      if (values?.length > 0) {
                        handleArrayValueChange(values, "business_entity_type");
                      }
                    }}
                    labelField="label"
                    valueField="value"
                    name="business_entity_type"
                    values={
                      basicDetails?.business_entity_type
                        ? [
                          {
                            value: basicDetails?.business_entity_type,
                            label: basicDetails?.business_entity_type,
                          },
                        ]
                        : []
                    }
                  />
                  {/* {errorFlag && !basicDetails?.business_entity_type && (
              <Label
                title={t("entrepenure_investment_basic_details.error_entity")}
                modeError={true}
              />
            )} */}
                </div>
                {basicDetails?.business_entity_type === "Other" && (
                  <div className="mb-2 w-100">
                    <RequiredLabel isRequired={true}>
                      Other Business Entity Type
                    </RequiredLabel>
                    <Form.Control
                      className={
                        isWarning(fields_to_improve, "business_entity_type_other")
                          ? "warning-field"
                          : ""
                      }
                      type="text"
                      placeholder="Other Business Entity Type"
                      name="business_entity_type_other"
                      value={basicDetails?.business_entity_type_other}
                      onChange={handleChange}
                    />
                    {errorFlag &&
                      basicDetails?.business_entity_type === "Other" &&
                      !basicDetails?.business_entity_type_other && (
                        <Label
                          title="Please enter other business entity type"
                          modeError={true}
                        />
                      )}
                  </div>
                )}

                <div className="d-flex gap-2 mb-2">
                  <div className="col-lg-6 w-50">
                    <div className="d-flex gap-2">
                      <RequiredLabel isRequired={false}>
                        {t(
                          "entrepenure_investment_basic_details.mobile_number_label",
                        )}
                      </RequiredLabel>
                      {basicDetails?.mobile_number &&
                        basicDetails?.mobile_verified_at && (
                          <div className="d-flex gap-1 justify-content-end">
                            <MdVerifiedUser color="green" className="" />
                            <span className="font-12 text-success">
                              {t("entrepenure_investment_basic_details.verified")}
                            </span>
                          </div>
                        )}
                      {
                        HelperService.removeDialCode(
                          basicDetails?.mobile_number,
                          basicDetails?.dial_code,
                        ) &&
                        !basicDetails?.mobile_verified_at && (
                          <span
                            id="verify-otp"
                            className="verify-otp-btn"
                            onClick={handleSendOTP}
                          >
                            Verify
                          </span>
                        )}
                    </div>
                    <PhoneInput1
                      value={basicDetails?.mobile_number}
                      errorFlag={errorFlag}
                      disabled={
                        basicDetails?.mobile_number &&
                        (from === "REVIEW" ||
                          from === "FROM_PROFILE_ANALYSIS" ||
                          status)
                      }
                      key={phoneKey}
                      dial_code={basicDetails?.dial_code}
                      handlePhoneNumberChange={(value: any, countryData: any) =>
                        handlePhoneChange(value, countryData)
                      }
                      className={
                        isWarning(fields_to_improve, "mobile_number")
                          ? "warning-field"
                          : ""
                      }
                    />

                    {errorFlag &&
                      basicDetails.mobile_number &&
                      !isMobileNumberValid(
                        basicDetails?.mobile_number,
                        basicDetails?.dial_code,
                      ) && (
                        <Label
                          title={t(
                            "entrepenure_investment_basic_details.error_mobile",
                          )}
                          modeError={true}
                        />
                      )}
                    {!HelperService.removeDialCode(
                      basicDetails?.mobile_number,
                      basicDetails?.dial_code,
                    ) &&
                      (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") ? (
                      <a
                        href="#"
                        className="mt-0 font-12 font-bold"
                        style={{
                          color: "#235299",
                          cursor: "pointer",
                          textDecoration: "underline",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          setShowChangeMobileModal(true);
                        }}
                      >
                        Add Mobile Number
                      </a>
                    ) : (from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") &&
                      basicDetails ? (
                      <div className="d-flex justify-content-between ">
                        <div
                          className="mt-0 font-14 font-bold cursor-pointer"
                          style={{ color: "#66C15E" }}
                          onClick={() => {
                            setShowChangeMobileModal(true);
                          }}
                        >
                          Change Mobile Number
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <div className="mb-2 col-lg-6" style={{ marginRight: "2px" }}>
                    <div className="d-flex justify-content-between">
                      <RequiredLabel isRequired={true}>
                        {t("entrepenure_investment_basic_details.email_label")}
                      </RequiredLabel>
                      {emailVerifiedAt && (
                        <div className="d-flex gap-1 justify-content-end">
                          <MdVerifiedUser color="green" className="" />
                          <span className="font-12 text-success">
                            {t("entrepenure_investment_basic_details.verified")}
                          </span>
                        </div>
                      )}
                    </div>
                    <Form.Control
                      type="text"
                      placeholder={t(
                        "entrepenure_investment_basic_details.enter_email",
                      )}
                      disabled={
                        from === "REVIEW" ||
                        from === "FROM_PROFILE_ANALYSIS" ||
                        status
                      }
                      name="email"
                      value={basicDetails?.email}
                      onChange={handleChange}
                      className={
                        (!basicDetails?.email && skipButtonClicked) ||
                          isWarning(fields_to_improve, "email")
                          ? "warning-field"
                          : ""
                      }
                    />
                    {((!skipButtonClicked && errorFlag && !basicDetails?.email) ||
                      (!skipButtonClicked &&
                        errorFlag &&
                        basicDetails?.email &&
                        !HelperService.isValidEmail(basicDetails?.email))) && (
                        <Label
                          title={t("entrepenure_investment_basic_details.error_email")}
                          modeError={true}
                        />
                      )}
                    {(from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS") && (
                      <div
                        className="mt-1 font-14 font-bold cursor-pointer text-end"
                        style={{ color: "#66C15E" }}
                        onClick={() => setShowEmail(true)}
                      >
                        Change Email
                      </div>
                    )}
                  </div>
                </div>
                {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                  <>
                    <PasswordInput
                      label="Password"
                      name="password"
                      value={basicDetails?.password || ""}
                      onChange={handleChange}
                      required
                      strongValidate
                      className={
                        !basicDetails?.password && skipButtonClicked
                          ? "warning-field"
                          : ""
                      }
                    />
                    {!skipButtonClicked && !basicDetails?.password && errorFlag && (
                      <Label title="Please enter password" modeError={true} />
                    )}
                  </>
                )}
              </>
            ) : null}

            {true && (
              <>
                <div className="mb-3 mt-2">
                  <div className="d-flex justify-content-between">
                    <div>
                      <RequiredLabel isRequired={false}>
                        {t("entrepenure_investment_basic_details.brief_about_label")}
                      </RequiredLabel>
                    </div>
                    <div className="d-flex justify-content-end mb-1">
                      <p className="font-10 font-bold mb-0">
                        {basicDetails?.brief_about_business?.length || 0}/700
                      </p>
                    </div>
                  </div>
                  <Form.Control
                    as="textarea"
                    placeholder={t(
                      "entrepenure_investment_basic_details.enter_description",
                    )}
                    className={
                      isWarning(fields_to_improve, "brief_about_business")
                        ? "warning-field"
                        : ""
                    }
                    style={{ height: "80px" }}
                    name="brief_about_business"
                    maxLength={700}
                    value={basicDetails?.brief_about_business}
                    onChange={handleChange}
                  />
                  {/* {errorFlag && !basicDetails?.brief_about_business && (
                  <Label
                    title={t("entrepenure_investment_basic_details.error_brief")}
                    modeError={true}
                  />
                )} */}
                </div>

                <div className="mb-4">
                  <div className="d-flex justify-content-between">
                    <div>
                      <RequiredLabel isRequired={false}>
                        {t(
                          "entrepenure_investment_basic_details.vision_mission_label",
                        )}
                      </RequiredLabel>
                    </div>
                    <div className="d-flex justify-content-end mb-1">
                      <p className="font-10 font-bold mb-0">
                        {basicDetails?.vision_mission?.length || 0}/700
                      </p>
                    </div>
                  </div>
                  <Form.Control
                    as="textarea"
                    placeholder={t(
                      "entrepenure_investment_basic_details.enter_description",
                    )}
                    className={
                      isWarning(fields_to_improve, "vision_mission")
                        ? "warning-field"
                        : ""
                    }
                    style={{ height: "80px" }}
                    name="vision_mission"
                    value={basicDetails?.vision_mission}
                    onChange={handleChange}
                    maxLength={700}
                  />
                  {/* {errorFlag && !basicDetails?.vision_mission && (
                  <Label
                    title={t("entrepenure_investment_basic_details.error_vision")}
                    modeError={true}
                  />
                )} */}
                </div>
              </>
            )}

            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                disabled={apiCallTriggered}
                id="save_basic_details"
                onClick={() => {
                  setSkipButtonClicked(false);
                  handleSaveBasicDetails(false);
                }}
              >
                {from === "REVIEW"
                  ? t("entrepenure_investment_basic_details.save")
                  : t("entrepenure_investment_basic_details.continue")}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  disabled={apiCallTriggered}
                  onClick={() => {
                    setSkipButtonClicked(true);
                    handleSaveBasicDetails(true);
                  }}
                >
                  Skip
                </Button>
              )}
            </div>
          </div>
        </CommonScrollbar>
        {showOTPVerify && (
          <VerifyMobileOTP
            contactInfo={{
              dial_code: dial_code,
              mobile_number: mobile_number,
              country_code: country_code,
            }}
            handleHide={(flag) => {
              if (flag) {
                setBasicDetails((prev: any) => ({
                  ...prev,
                  mobile_number: mobile_number,
                  mobile_verified_at: new Date(),
                }));
              }
              setShowOTPVerify(false);
            }}
            show={showOTPVerify}
          />
        )}
        {showChangeMobileModal && (
          <ChangeMobileNumberModal
            onHide={() => {
              setShowChangeMobileModal(false);
            }}
            mode={basicDetails?.mobile_number ? "UPDATE" : "ADD"}
            onSave={(dialCode, mobile, country_code1) => {
              const cleanMobile = HelperService.removeDialCode(mobile, dialCode);
              setdial_Code(dialCode);
              setMoible_number(cleanMobile);
              setCountryCode(country_code1);
              setBasicDetails((prev: any) => ({
                ...prev,
                dial_code: dialCode,
                country_code: country_code1,
                mobile_number: cleanMobile,
                mobile_verified_at: new Date(),
              }));
              if (impIds?.uuid) {
                getBasicDetails();
              }
            }}
            defaultDialCode={basicDetails?.dial_code}
            show={showChangeMobileModal}
          />
        )}

        {showEmail && (
          <ChangeEmailModal
            onHide={() => {
              setShowEmail(false);
            }}
            onSave={(email) => {
              setEmail(email);
              setShowEmail(false);
              setShowEmailOTPVerify(true);
            }}
            show={showEmail}
          />
        )}
        <VerifyEmailOTP
          email={email}
          handleHide={(flag) => {
            if (flag) {
              setBasicDetails((prev: any) => ({
                ...prev,
                email: email,
                email_verified_at: new Date(),
              }));
            }
            setShowEmailOTPVerify(false);
          }}
          show={showEmailOTPVerify}
        />
      </div>
    </>

  );
};

export default BasicDetails;
